import React, { useEffect } from 'react';
import { useBackgroundJobs } from '../context/BackgroundJobsContext';

const TOAST_DURATION_MS = 6000;

function ToastItem({ id, type, label, eventName, onDismiss }) {
  useEffect(() => {
    const t = setTimeout(() => onDismiss(id), TOAST_DURATION_MS);
    return () => clearTimeout(t);
  }, [id, onDismiss]);

  return (
    <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-3 flex items-start gap-2">
      <span
        className="flex-shrink-0 w-8 h-8 rounded-full bg-green-100 flex items-center justify-center text-green-600"
        aria-hidden
      >
        ✓
      </span>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-gray-800">
          {type === 'encoding' ? 'Encoding completed' : type === 'subscription_approved' ? 'Plan approved' : 'Deletion completed'}
        </p>
        <p className="text-xs text-gray-600 truncate">{label}</p>
        {eventName && <p className="text-xs text-gray-500 mt-0.5">Event: {eventName}</p>}
      </div>
      <button
        type="button"
        onClick={() => onDismiss(id)}
        className="flex-shrink-0 text-gray-400 hover:text-gray-600 p-0.5"
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
}

const CompletionToasts = () => {
  const { completions, dismissCompletion } = useBackgroundJobs();

  if (completions.length === 0) return null;

  return (
    <div
      className="fixed top-4 right-4 z-[9998] flex flex-col gap-2 w-72 max-w-[calc(100vw-2rem)]"
      aria-live="polite"
      aria-label="Completion notifications"
    >
      {completions.map((c) => (
        <ToastItem
          key={c.id}
          id={c.id}
          type={c.type}
          label={c.label}
          eventName={c.eventName}
          onDismiss={dismissCompletion}
        />
      ))}
    </div>
  );
};

export default CompletionToasts;
